import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { injectIntl, FormattedHTMLMessage } from 'react-intl'
import { userActions } from '../../redux/actions'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import LoginForm from '../../components/Form/LoginForm/LoginForm'
import IncapsulaCaptchModal from '../../components/Modal/IncapsulaCaptchaModal/IncapsulaCaptchaModal'

import './Login.scss'
import { currentUser } from '../../redux/reducers/user.reducers'

const Login = props => {
  const { loginLoading, incapsula, intl, login, isModal = false } = props
  const handleLogin = async values => {
    await login(values.email, values.password)
  }

  const label = intl.formatMessage({ id: 'page.loginPage.title.heroTitle' })
  return (
    <div className="login-page" aria-labelledby="login-page-title">
      <Helmet>
        <title>{label}</title>
        <meta
          name="description"
          content="AMD Rewards – Redeem your promotional code for AMD game bundles"
        />
      </Helmet>
      <div className="container mt-5 mb-5">
        <IncapsulaCaptchModal isOpen={!!incapsula} source={incapsula} />
        <div className="row">
          <div className="col-md-12">
            <h1 className="page-title" id="login-page-title">
              <FormattedMessage id="page.loginPage.title.heroTitle" />
            </h1>
            <p className="login-note">
              <FormattedHTMLMessage id="page.loginPage.title.description" />
            </p>
            <p className="login-note">
              <FormattedHTMLMessage id="page.loginPage.title.note" />
            </p>
          </div>
          <div className="col-md-6">
            <LoginForm
              isModal={isModal}
              className="mb-3"
              loginLoading={loginLoading}
              onSubmit={handleLogin}
            />
            {!isModal && (
              <>
                <div className="forgot-password my-3">
                  <Link to="/forgot-password">
                    <FormattedMessage id="global.label.forgotPassword" />
                  </Link>
                </div>
                <div className="forgot-password my-3">
                  <Link to="/register">
                    <FormattedMessage id="global.label.createAccount" />
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
  getSessionUser: () => dispatch(userActions.getSessionUser()),
  login: (...args) => dispatch(userActions.login(...args)),
})

const mapStateToProps = state => ({
  user: currentUser(state),
  loginLoading: state.userReducers.loginLoading,
  incapsula: state.userReducers.recapsula,
})

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Login))
